import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {getLikes} from "./likesAPI";

const initialState = {
    videoDetails: {},
    isLoading: false,
    isError: false,
    error: "",
}

// // async thunk
// export const fetchLikes = createAsyncThunk(
//     "likes/fetchLikes",
//     async (id, likesLocal) => {
//         console.log("likeSliceConsole", likesLocal);
//         const likesNumber = await getLikes(id, likesLocal);
//         return likesNumber;
//     }
// );

// async thunk
export const updateLikes = createAsyncThunk(
    "likes/updateLikes",
    async (obj) => {
        // console.log(obj);
        const response = await getLikes(obj);
        return response;
    }
);

const likesSlice = createSlice({
    name: 'likes',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(updateLikes.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(updateLikes.fulfilled, (state, action) => {
                state.isLoading = false;
                state.videoDetails = action.payload;
            })
            .addCase(updateLikes.rejected, (state, action) => {
                state.isLoading = false;
                state.videoDetails = {};
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});


export default likesSlice.reducer;